import React from 'react';
import { IconButton, Tooltip, Badge } from '@mui/material';
import { AccessTime } from '@mui/icons-material';

const ClockIcon = ({ 
  onClick, 
  hasSchedule = false,
  tooltip = "Set availability schedule",
  size = "medium",
  color = "primary",
  sx = {}
}) => {
  return (
    <Tooltip title={tooltip}>
      <IconButton 
        onClick={onClick}
        size={size}
        color={color}
        sx={{ 
          position: 'relative',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
          },
          ...sx
        }}
      >
        <Badge 
          variant="dot" 
          color="success" 
          invisible={!hasSchedule}
          sx={{
            '& .MuiBadge-dot': {
              top: 5,
              right: 5,
              width: 8,
              height: 8,
            }
          }}
        >
          <AccessTime />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default ClockIcon;